import { background } from './zephyrs.mjs'
import { imgproxySettings, mobileImgproxySettings } from './shared.mjs'

export const body = {
  id: 'body',
  name: 'Body',
  imgproxySettings,
  mobileImgproxySettings,
  hasOptions: false,
  pathTemplate: 'gs://sg360/240730/Boston Red Sox/MLB-Z_red sox-{nnn}-B.png',
}

export default {
  supports360: false,
  layers: [body, background],
  resolveOptions: () => ({}),
}
